module.exports = __webpack_public_path__ + "img/779.3c94468b.jpg";